import { Link } from "react-router-dom";

function Footer() {

    return (
        <footer className="footer">

            <a href="#top">
                Nach oben
            </a>


            <Link to="/impressum">
                Impressum
            </Link>


            <a
                className="social-link"
                href="https://www.facebook.com/ivan.jorg"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
            >
                <img
                    src="/Fotos/2023_Facebook_icon.svg.png"
                    alt="Facebook"
                    className="social-icon"
                />
            </a>


            <a
                className="social-link"
                href="https://www.instagram.com/ivanretojoerg/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
            >
                <img
                    src="/Fotos/Instagram_icon.png"
                    alt="Instagram"
                    className="social-icon"
                />
            </a>

        </footer>
    );
}

export default Footer;